const configuration = {
    maxItems: 3,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 6000
}

export default configuration;